{
  "sendMessage": "Send a message...",
  "messageInput": "Message input",
  "copy": "Copy",
  "exportAsMarkdown": "Export as Markdown",
  "refresh": "Refresh",
  "previous": "Previous",
  "next": "Next",
  "cancel": "Cancel",
  "update": "Update",
  "somethingWentWrong": "Something went wrong",
  "assistantError": "The assistant couldn't complete your request. You can try again or rephrase your message.",
  "edit": "Edit",
  "scrollToBottom": "Scroll to bottom",
  "newThread": "New Thread",
  "archiveThread": "Archive thread",
  "back": "Back",
  "continue": "Continue",
  "complete": "Complete",
  "current": "Current",
  "showDetails": "Show details",
  "checkConsoleForDetails": "Check console for details",
  "dataPending": "data pending",
  "noDataFound": "No data found for output key \"{{outputKeyRef}}\". The query may still be processing.",
  "noData": "No {{blockType}} data",
  "queryReturnedNoResults": "The query returned no results.",
  "agentProgress": "{{agent}} is {{progress}}...",
  "toolRunSummary_one": "Used {{count}} {{agent}} insight",
  "toolRunSummary_other": "Used {{count}} {{agent}} insights",
  "tools": {
    "$default": {
      "running": "Running...",
      "awaitingInput": "Awaiting your input...",
      "complete": "Completed",
      "error": "Something went wrong",
      "cancelled": "Cancelled",
      "progress": "thinking"
    },
    "plan": {
      "running": "Planning...",
      "complete": "Execution plan created",
      "error": "Plan creation failed",
      "progress": "planning"
    },
    "describeViews": {
      "running": "Fetching view schema...",
      "complete": "View schema fetched",
      "progress_zero": "fetching view schema",
      "progress_one": "fetching {{count}} view schema",
      "progress_other": "fetching {{count}} view schemas"
    },
    "queryKnowledgeGraph": {
      "running": "Querying knowledge graph...",
      "complete": "Query complete",
      "error": "Query error: {{error}}",
      "progress": "looking up data"
    },
    "transformDataset": {
      "running": "Transforming dataset...",
      "complete": "Transform complete",
      "error": "Dataset transform error: {{error}}",
      "progress": "processing data"
    },
    "showDashboard": {
      "running": "Building insights...",
      "complete": "Dashboard rendered",
      "error": "An error occurred while displaying the dashboard.",
      "loading": "Loading insights…"
    },
    "showInsights": {
      "running": "Generating insights...",
      "complete": "Insights generated",
      "error": "An error occurred while generating agent insights."
    },
    "createResponse": {
      "error": "An error occurred while generating the agent response."
    },
    "askUserQuestion": {
      "complete": "Completed",
      "completeNoChoices": "No choices were made.",
      "completeChoiceReceived": "Choice received",
      "error": "No answer provided to question."
    }
  }
}
